module.exports = __webpack_public_path__ + "img/tk-back.245424c6.png";